import { render, staticRenderFns } from "./readingfill.vue?vue&type=template&id=f35f27a6&scoped=true&"
import script from "./readingfill.vue?vue&type=script&lang=js&"
export * from "./readingfill.vue?vue&type=script&lang=js&"
import style0 from "./readingfill.vue?vue&type=style&index=0&lang=css&"
import style1 from "./readingfill.vue?vue&type=style&index=1&id=f35f27a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35f27a6",
  null
  
)

export default component.exports